<template>
  <slide-out
    dock="right"
    :size="sideOutCurrentSize"
    ref="filterSlideout"
    @resize="OnResize"
    :min-size="sideOutMinSize"
    :allow-resize="nested ? false : true"
    :append-to="nested ? '' : '#app'"
    :visible.sync="slideouts.active"
    v-on:close="onSlideoutClosing">
    <template v-slot:header>
			<h3 v-if="isFetching" class="font-weight-medium pa-1" small>
        <v-progress-circular :size="16" width="2" indeterminate class="mr-1"></v-progress-circular>
        Loading Filters ...
      </h3>
      <h3 v-else class="font-weight-medium pa-1" small><v-icon left>mdi-filter-outline</v-icon> Filters</h3>
      <v-btn @click="closeUpdateSlideout()" icon>
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>

    <div v-if="!isFetching" class="pa-5">
      <v-expansion-panels id="corrosion-filters-panel" multiple>
        <template v-for="(options, filter) in filters">
          <v-expansion-panel v-if="!!options.length" :key="filter">
            <v-expansion-panel-header v-ripple>{{ getFilterDisplay(filter) }}</v-expansion-panel-header>
            <v-expansion-panel-content class="px-4 pb-4 pt-0">
              <v-checkbox
                hide-details
                v-for="option in options"
                @change="updateFilters(filter, option)"
                :input-value="corrosionOptions?.filters[filter]?.includes(option)"
                :key="`${filter}-${option}`"
                :label="option ?? getDefaultDisplay(filter)"/>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </template>
      </v-expansion-panels>
    </div>
    <template v-slot:footer>
      <v-card-actions>
        <v-btn text color="error" @click="closeUpdateSlideout()">
          <v-icon left>mdi-chevron-left</v-icon> Close
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn large text color="primary" @click="resetAllFilters()">
          <v-icon left>mdi-refresh</v-icon> Reset All
        </v-btn>
      </v-card-actions>
    </template>
  </slide-out>
</template>

<script>
import { getFilterOptionDisplayName } from '../config/helper';

  export default {
    name: 'corrosion-analyser-filters',
    data() {
      return {
        valid: false,
        isFetching: false,
        selected: {},
        modal: false,
        selectedCemented: {},
        slideouts: {
          active: false,
          isLoading: false,
          isClosing: false,
          hasChanges: false,
        },
      };
    },
    props: {
      nested: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      sideOutMinSize: {
        get() {
          return this.$store.getters['GET_SIDOUT_MINSIZE'];
        },
        set(val) {
          this.$store.commit('SET_SIDOUT_MINSIZE', val);
        },
      },
      sideOutCurrentSize: {
        get() {
          return this.$store.getters['GET_SIDOUT_CURRENTSIZE'];
        },
        set(val) {
          this.$store.commit('SET_SIDOUT_CURRENTSIZE', val);
        },
      },
      corrosionOptions: {
        get() {
          return this.$store.getters['CORROSION_ANALYSER/GET_OPTIONS'];
        },
        set(val) {
          this.$store.commit('CORROSION_ANALYSER/SET_OPTIONS', val);
        },
      },
      filters: {
        get() {
          return this.$store.getters['CORROSION_ANALYSER/GET_FILTERS'];
        },
        set(val) {
          this.$store.commit('CORROSION_ANALYSER/SET_FILTERS', val);
        },
      },
    },
    methods: {
      OnResize() {
        let filterSlideout = this.$refs.filterSlideout;
        this.sideOutCurrentSize = filterSlideout.resizeValue;
      },
      onSlideoutClosing() {
        this.$emit('close');
        this.closeUpdateSlideout();
      },
      closeUpdateSlideout() {
        this.slideouts.active = false;
      },
      open() {
        this.slideouts.active = true;
        this.isFetching = true;
        this.$store.dispatch('CORROSION_ANALYSER/GET_FILTERS', {
          assetId: this.$route.params.id
        }).finally(() => {
          this.isFetching = false;
        });
      },
			updateFilters(category, option) {
				let filters = this.corrosionOptions.filters;

        if (!filters[category]) {
          filters[category] = [];
        }

				if (filters[category]?.includes(option)) {
					filters[category] = filters[category].filter((opt) => opt !== option);
				} else {
					filters[category].push(option);
				}

				this.corrosionOptions = {
          ...this.corrosionOptions,
          filters: {
            ...filters,
          }
        };
			},
      getDefaultDisplay(category) {
        switch (category) {
          case 'status':
            return 'Open'
          default:
            return '_blank'
        }
      },
      getFilterDisplay(filter) {
        return getFilterOptionDisplayName(filter);
      },
			resetAllFilters() {
				this.corrosionOptions = {
					...this.corrosionOptions,
          filters: {
            ...this.corrosionOptions.filters,
            ...Object.fromEntries(Object.keys(this.filters).map((key) => [key, []])),
          }
				};
			},
		},
		created() {
			if (this.nested) {
				this.sideOutCurrentSize = '80vw';
				this.sideOutMinSize = '80vw';
			}
    },
    watch: {
      nested: {
        handler() {
          this.nested ? (this.sideOutCurrentSize = '80vw') : (this.sideOutCurrentSize = '35vw');
          this.nested ? (this.sideOutMinSize = '80vw') : (this.sideOutMinSize = '35vw');
        },
        deep: true,
      },
    },
  };
</script>
<style lang="scss">
  #corrosion-filters-panel {
    & .v-expansion-panel {
      border: 1px solid #e0e0e00f;
      border-radius: 8px;

      &::after {
        border: none;
      }

      &::before {
        box-shadow: none;
      }

      .v-expansion-panel-header {
        height: 40px;
        text-transform: capitalize;
      }
    }

    & .v-input--selection-controls:first-child {
      margin-top: 0;
    }
  }
</style>
